import { useState, useCallback } from "react";
import { SIDEBAR_ITEMS } from "../services/utils/constants";

export const useSidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState(SIDEBAR_ITEMS);

  const toggleCollapsed = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  const toggleMenuItems = useCallback((itemId) => {
    setMenuItems((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId
          ? { ...item, expanded: !item.expanded }
          : item
      )
    );
  }, []);

  const setActiveMenuItem = useCallback((itemId) => {
    setMenuItems((prevItems) => {
      return prevItems.map((item) => {
        // Reset all items first
        const resetItem = {
          ...item,
          active: false,
          subItems: item.subItems?.map(subItem => ({
            ...subItem,
            active: false
          }))
        };

        // Check if this is a top-level item being activated
        if (item.id === itemId) {
          return {
            ...resetItem,
            active: true
          };
        }
        
        // Check if any subitem should be activated
        if (item.hasSubItems && item.subItems) {
          const subItemToActivate = item.subItems.find(subItem => subItem.id === itemId);
          if (subItemToActivate) {
            return {
              ...resetItem,
              active: false,
              subItems: item.subItems.map(subItem => ({
                ...subItem,
                active: subItem.id === itemId
              }))
            };
          }
        }
        
        return resetItem;
      });
    });
  }, []);

  return { isCollapsed, menuItems, toggleCollapsed, toggleMenuItems, setActiveMenuItem };
};
